module.exports = __webpack_public_path__ + "static/media/residentiel-17.ef235e8f.jpg";